import classNames from "classnames";
import { popup as styles } from "./styles";
import { withStyles, Grid, Typography, Button } from "@material-ui/core";

import PropTypes from "prop-types";
import React, { Component } from "react";
import { ReactComponent as CloseIco } from "../../../assets/images/icons/closeSlideShow.svg";
import { ReactComponent as Vue360IcO } from "../../../assets/images/icons/vue360.svg";

class Popup extends Component {


	render() {
		const { popup, classes } = this.props;
		let { open, x, y, color, poi, onClickPoi, onClose } = popup;

		let pieces = poi ? poi.type.replace(/(?!\/)\D+/gimu, "") : 0;
		if (poi && (poi.type === "ST" || poi.type === "st")) {
			pieces = 1;
		}

		if (poi && !poi.hasOwnProperty("description")) {
			poi.description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit.";
		}

		let btnVisible = true
		if(poi && (poi.visit360 === "")){
			btnVisible=false;
		}

		return (
			<Grid
				className={classes.wrapper}
				container
				direction="column"
				alignItems="center"
				alignContent="center"
				style={{
					display: open ? "flex" : "none",
					border: `1px solid ${color}`,
					padding: "10px",
					top: y,
					left: x,
					boxShadow: "0 0 6px 0 rgba(0,0,0,.3)"
				}}
			>
				<Button
					onClick={onClose}
					style={{
						position: "absolute",
						top: "-26px",
						right: "-26px",
						minWidth: "auto",
						marginRight: 0,
						borderRadius: "0px",
						border: "1px solid " + color,
						padding: "1px",
						backgroundClip: "content-box",
						backgroundColor: color,
						width: "54px",
						height: "54px",
						transform: "rotate(45deg)",
						zIndex: "100"
					}}>
					<CloseIco style={{
						transform: "rotate(-45deg)",
						fill: "rgba(254, 253, 248, 1)",
						width: "26px",
						height: "26px"
					}} />
				</Button>
				<Grid
					className={classes.top}
					item
					xs={4}
					style={{
						color: color
					}}
				>
					<Typography className={classes.lot} variant="h1" color="inherit">
						{poi ? poi.lot : null}
					</Typography>
				</Grid>

				<Grid className={classes.center} item xs={8}>
					<Typography
						className={classNames(classes.value, classes.valueDescription)}
						style={{
							color: "black"
						}}
					>
						{poi ? poi.description : null}
					</Typography>
				</Grid>
				{btnVisible &&

				<Grid className={classes.bottom} item xs={8}>
					<Button
						style={{
							width: "200px",
							height: "40px",
							background: color,
							color: "#FFF"
						}}
						onClick={() => {
							onClickPoi(poi.lot);
						}}
					>
						<Vue360IcO style={{
							//fill: "rgba(254, 253, 248, 1)"
							margin: "10px"
						}} />
						Vue 360°
					</Button>
				</Grid>
				}
			</Grid>
		);
	}

}


Popup.propTypes = {
	classes: PropTypes.object.isRequired,
	popup: PropTypes.object.isRequired
};

export default withStyles(styles)(Popup);
